import React from 'react';
import './Loader.scss';

const Loader = () => <div className="loader sq-50 circle m-auto m-t-10 m-b-10 ttn-3" />;

export default Loader;
